module.exports = __webpack_public_path__ + "img/11-1.4b748d75.png";